<template>

  <my-task :is-ordinary-consumer="false" :operation="taskManageOperation"></my-task>

</template>

<script>
import MyTask from "./MyTask";

export default {
  name: "TaskManage",
  components: {
    MyTask
  },
  data: function (){
    return{
      taskManageOperation: null,
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/functions/task/TaskManage.vue